import { render, staticRenderFns } from "./settingAuth.vue?vue&type=template&id=ec088f46&scoped=true"
import script from "./settingAuth.vue?vue&type=script&lang=js"
export * from "./settingAuth.vue?vue&type=script&lang=js"
import style0 from "./settingAuth.vue?vue&type=style&index=0&id=ec088f46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec088f46",
  null
  
)

export default component.exports